module.exports = __webpack_public_path__ + "static/media/skypeIcon.425a8435.svg";